module.exports = __webpack_public_path__ + "img/3.013c97a0.jpg";